/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetUserPreferencesStatus200 } from '../models/GetUserPreferences'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getUserPreferences } from '../clients/axios/getUserPreferences'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUserPreferencesQueryKey = () => [{ url: '/user/preferences' }] as const

type GetUserPreferencesQueryKey = ReturnType<typeof getUserPreferencesQueryKey>

export function getUserPreferencesQueryOptions(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getUserPreferencesQueryKey()
  return queryOptions<GetUserPreferencesStatus200, ResponseErrorConfig<Error>, GetUserPreferencesStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await getUserPreferences({ ...config, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @summary Get Preferences
 * {@link /user/preferences}
 */
export function useGetUserPreferences<TData = GetUserPreferencesStatus200, TQueryData = GetUserPreferencesStatus200, TQueryKey extends QueryKey = GetUserPreferencesQueryKey>(options: {
  query?: Partial<QueryObserverOptions<GetUserPreferencesStatus200, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getUserPreferencesQueryKey()

  const queryResult = useQuery({
   ...getUserPreferencesQueryOptions(config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
